/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "fees": {
        "nested": {
          "SimpleRate": {
            "fields": {
              "basisPoints": {
                "type": "int32",
                "id": 1,
                "rule": "optional"
              },
              "fixedAmount": {
                "type": "int32",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fees?.nested?.SimpleRate) {
	$root.addJSON(jsonData);
}

/**
 * @desc Describes a simple rate with a variable and fixed component.
 *
 * SOURCE SimpleRate @ squareup/fees/models.proto at 72:1
 */
export const SimpleRate = $root.lookupType('squareup.fees.SimpleRate');
fixType(SimpleRate);
Builder.createAndAttachToType(SimpleRate);
